export const calculateHeight = (element) => {
    element.style.height = "auto";
    element.style.height = `${element.scrollHeight + 5}px`;
};
